import useGetTreatment from 'hooks/treatments/useGetTreatment'
import { TreatmentFlags, treatmentFlagValues } from 'constants/treatments'
import { isPatientUser } from 'utils/common'

/** Patients only; COE and users without consent receive control. */
export function useMidResultsFilterNudge(): { isEnabled: boolean } {
  const isPatient = isPatientUser()
  const treatment = useGetTreatment(
    TreatmentFlags.MID_RESULTS_FILTER_NUDGE,
    isPatient
  )

  return { isEnabled: isPatient && treatment === treatmentFlagValues.ON }
}

export default useMidResultsFilterNudge
